import React from 'react';

interface IGameComparisonIconProps {
  className?: string;
  style?: React.CSSProperties;
}

const GameComparisonIcon: React.FC<IGameComparisonIconProps> = ({
  className,
  style,
}) => (
  <svg
    className={className}
    style={style}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M5.65039 1.71973C6.09204 1.71994 6.4502 2.07783 6.4502 2.51953C6.4502 2.96123 6.09204 3.31912 5.65039 3.31934H3.5C3.38954 3.31934 3.2998 3.40907 3.2998 3.51953V12.5195C3.2998 12.63 3.38954 12.7197 3.5 12.7197H12.5C12.6105 12.7197 12.7002 12.63 12.7002 12.5195V10.0996C12.7004 9.65796 13.0583 9.2998 13.5 9.2998C13.9417 9.2998 14.2996 9.65796 14.2998 10.0996V12.5195C14.2998 13.5136 13.4941 14.3193 12.5 14.3193H3.5C2.50589 14.3193 1.7002 13.5136 1.7002 12.5195V3.51953C1.7002 2.52542 2.50589 1.71973 3.5 1.71973H5.65039ZM12.5 1.71973C13.4941 1.71973 14.2998 2.52542 14.2998 3.51953V6.51953C14.2998 6.96136 13.9418 7.32031 13.5 7.32031C13.0582 7.32031 12.7002 6.96136 12.7002 6.51953V4.43066L8.06543 9.06543C7.75301 9.37785 7.24699 9.37785 6.93457 9.06543C6.62215 8.75301 6.62215 8.24699 6.93457 7.93457L11.5498 3.31934H9.5C9.05817 3.31934 8.7002 2.96136 8.7002 2.51953C8.7002 2.0777 9.05817 1.71973 9.5 1.71973H12.5Z"
      fill="currentColor"
    />
  </svg>
);

export default GameComparisonIcon;
